import { GET_NDHM_HOST } from "../../constants/env";
import fetch from "../../fetch-client";
import { AxonGenericApiResponse } from "../../types/axon";

export default async function postCheckHprExist({
  txn_id,
}: {
  txn_id: string;
}): Promise<
  AxonGenericApiResponse<{
    token: string;
    hpr_id_number: string;
    category_id: number;
    sub_category_id: number;
    txn_id: string;
    name: string;
    gender: string;
    year_of_birth: string;
    month_of_birth: string;
    day_of_birth: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    state_code: string;
    district_code: string;
    state_name: string;
    district_name: string;
    address: string;
    pincode: string;
    profile_photo: string;
    mobile: string;
    hpr_id: string;
    new: boolean;
  }>
> {
  try {
    const NDHM_HOST = GET_NDHM_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const body = JSON.stringify({ txn_id });
    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body,
      mode: "cors",
      credentials: "include",
    };
    const response = await fetch(
      `${NDHM_HOST}/abdm/nhpr/v1/hpr/aadhaar/check/exist`,
      requestOptions,
    );
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
